/* docs/API.md → Enums, Notifications. */
export enum NotificationKind {
    Assigned  = 'assigned',
    Commented = 'commented',
    DueSoon   = 'due_soon',
    Overdue   = 'overdue',
}
